import React, { useState, useEffect } from 'react';
import StockChartTable from './StockChartTable';
import LoginPage from './LoginPage';
import { isAuthenticated, getUsername, clearToken } from './services/apiService';

function App() {
  const [authenticated, setAuthenticated] = useState(isAuthenticated());
  const [username, setUsername] = useState(getUsername());

  useEffect(() => {
    const handleAuthExpired = () => {
      setAuthenticated(false);
      setUsername(null);
    };
    window.addEventListener('auth-expired', handleAuthExpired);
    return () => window.removeEventListener('auth-expired', handleAuthExpired);
  }, []);

  const handleLogin = (user) => {
    setAuthenticated(true);
    setUsername(user);
  };

  const handleLogout = () => {
    clearToken();
    setAuthenticated(false);
    setUsername(null);
  };

  if (!authenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <StockChartTable username={username} onLogout={handleLogout} />
    </div>
  );
}

export default App;